import { List, Typography } from "antd";
import { CSSProperties } from "react";
import { UserAvatar, UserData } from "./UserAvatar";

const { Text } = Typography;

export interface ContributorsListProps {
  users: (UserData & { contribution?: string })[];
  showRoles?: boolean;
  showEmail?: boolean;
  showContribution?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const ContributorsList: React.FC<ContributorsListProps> = ({
  users,
  showRoles = false,
  showEmail = false,
  showContribution = true,
  className,
  style,
}) => {
  return (
    <List
      className={className}
      style={style}
      itemLayout="horizontal"
      dataSource={users}
      renderItem={(user) => (
        <List.Item>
          <List.Item.Meta
            avatar={
              <UserAvatar user={user} size="medium" showTooltip={false} />
            }
            description={
              showEmail &&
              user.email && <Text type="secondary">{user.email}</Text>
            }
          />
          {showContribution && user.contribution && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {user.contribution}
            </Text>
          )}
        </List.Item>
      )}
    />
  );
};
